import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
axios.defaults.withCredentials = true;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    axios
      .get(`${API}/api/auth/me`)
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));

    // Auto-refresh access token every 50 minutes (token expires in 60)
    const refreshInterval = setInterval(async () => {
      try {
        await axios.post(`${API}/api/auth/refresh`);
      } catch {
        // Refresh failed — user will need to log in again
      }
    }, 50 * 60 * 1000);
    return () => clearInterval(refreshInterval);
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { email, password });
    setUser(data);
    return data;
  };

  const register = async (email, password, name, phone, verification_code, join_code) => {
    const payload = { email, password, name, phone, verification_code };
    if (join_code) payload.join_code = join_code;
    const { data } = await axios.post(`${API}/api/auth/register`, payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    await axios.post(`${API}/api/auth/logout`);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
